import { createAction, props } from '@ngrx/store';

import { KeyValueDict } from '@global/infrastructure/interfaces/key-value-dict';

export const addConviction = createAction(
  '[YourConvictions] Add Conviction'
);

export const updateConviction = createAction(
  '[YourConvictions] Update Conviction',
  props<{ conviction: KeyValueDict<any>, index: number }>()
);

export const updateEditFormStatus = createAction(
  '[YourConvictions] Update Edit Form Status',
  props<{ isShowConvictionForm: boolean, index: number }>()
);

export const removeConviction = createAction(
  '[YourConvictions] Remove Conviction',
  props<{ index: number }>()
);

export type YourConvictionsActionsUnion = ReturnType<typeof addConviction | typeof updateConviction | typeof updateEditFormStatus>;
